import { supabase } from "../config/supabaseClient";
import { FcGoogle } from "react-icons/fc";
import { FaTimes } from "react-icons/fa";
import "./LoginModal.css";
import logo from "../assests/logo.png";

export default function LoginModal({ onClose, pendingRoute }) {  // ← adaugi prop aici
 const handleGoogleLogin = async () => {
    // Salvează ruta ÎNAINTE de a pleca la Google
    if (pendingRoute) {
      sessionStorage.setItem("pendingRoute", pendingRoute);
    }

    const { error } = await supabase.auth.signInWithOAuth({
      provider: "google",
      options: {
        redirectTo: `${window.location.origin}/auth/callback`,
      },
    });

    if (error) console.error("Eroare login:", error.message);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <FaTimes />
        </button>
        <div className="modal-content">
          <img src={logo} alt="FindMyPet" className="modal-logo" />
          <h2>Intră în cont</h2>
          <p>Ai nevoie de un cont pentru a posta un anunț.</p>
          <button onClick={handleGoogleLogin} className="btn-google">
            <FcGoogle size={22} />
            Continuă cu Google
          </button>
        </div>
      </div>
    </div>
  );
}